<template>
  <div>
    <Typography h2 bold label="วิเคราะห์ข้อมูลระบบ" />

    <div class="ml-5 mt-4">
      <Typography h2 bold label="Log in TechHunt / redeem" />
      <v-layout warp class="mt-2" justify-space-between>
        <v-card
          style="
            padding: 15px;
            width: 30%;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
            border-radius: 10px;
          "
        >
          <Typography left h5 medium label="ผู้ใช้งานทั้งหมด" />
          <Typography center h1 bold :label="tafficReport.user" />
          <!-- <tween-num :value="664253" :initial="0" :formatter="numberFormat"></tween-num> -->
          <Typography right h5 medium label="คน" />
        </v-card>
        <v-card
          class="text-xs-center"
          style="
            padding: 15px;
            width: 30%;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
            border-radius: 10px;
          "
        >
          <Typography left h5 medium label="การแลกต่อวัน" />
          <Typography center h1 bold :label="tafficReport.coupon" />
          <Typography right h5 medium label="คูปอง" />
        </v-card>
        <v-card
          class="text-xs-center"
          style="
            padding: 15px;
            width: 30%;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
            border-radius: 10px;
          "
        >
          <Typography left h5 medium label="การดูรายการสินค้า" />
          <Typography center h1 bold :label="tafficReport.view" />
          <Typography right h5 medium label="รายการ" />
        </v-card>
      </v-layout>

      <Typography h2 bold label="Top View" class="mt-4" />
      <v-layout v-if="topProduct && topProduct.length" row wrap>
        <v-layout column>
          <v-flex xs12 sm6>
            <v-card
              v-for="(item, index) in topProduct"
              :key="`top-product-key-${item.productid}`"
              style="
                padding: 15px;
                box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
                border-radius: 10px;
                display: flex;
                gap: 10px;
                justify-content: space-between;
              "
              class="mt-2"
            >
              <div style="display: flex;">
                <Typography h5 bold :label="`อันดับที่ ${index + 1}`" />
                <Typography h5 medium :label="item.productname" />
              </div>
              <div style="display: flex;gap: 10px">
              <Typography h5 medium :label="`view `" />
                <Typography h5 medium :label="item.view" />
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>

      <Typography h2 bold label="Top 10 Review" class="mt-4" />
      <v-layout row>
        <v-flex xs12 sm12>
          <v-card
            v-for="(item, index) in topData"
            :key="`top-product-key-${item.productid}`"
            style="
              padding: 15px;
              box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
              border-radius: 10px;
              display: flex;
              gap: 10px;
              justify-content: space-between;
            "
            class="mt-2"
          >
            <div style="display: flex;">
              <Typography h5 medium :label="`${index + 1}.`" />
              <Typography h5 medium :label="item.productname" />
            </div>
            <div style="display: flex;gap: 10px;">
              <Typography h5 medium :label="`score `" />
              <Typography h5 medium :label="item.score" />
            </div>
          </v-card>
        </v-flex>

        <!-- <v-flex xs12 sm6>
          <div v-for="(item, index) in top5" :key="`key-${item.productid}`">
            <span @click="openUrl(`${techhuntUrl}product?id=${item.productid}`)" class="cursor-5"
              >{{ index + 1 }}. {{ item.productname }}</span
            >
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div v-for="(item, index) in topOther" :key="`key-${item.productid}`">
            <span @click="openUrl(`${techhuntUrl}product?id=${item.productid}`)" class="cursor-5"
              >{{ index + 6 }}. {{ item.productname }}</span
            >
          </div>
        </v-flex> -->
      </v-layout>
      <Typography h2 bold label="Voucher report" class="mt-4" />
      <v-layout row wrap>
        <v-flex xs8 style="display: flex; align-items: center; gap: 10px">
          <multiselect
            v-model="filter.campaign"
            :options="campaign"
            label="campaignname"
            selectLabel
            selectedLabel
            placeholder="เลือกแคมเปญ"
            @input="search"
            deselect-label
          ></multiselect>
          <!-- <div class="form-control">
            <datepicker @input="search" v-model="filter.dateFrom" placeholder="จาก" style="margin: 0px !important;"></datepicker>
          </div>
          <div class="form-control">
            <datepicker @input="search" v-model="filter.dateTo" placeholder="ถึง" style="margin: 0px !important;"></datepicker>
          </div> -->
          <div class="form-control" style="width: 65%">
            <date-picker
              range
              @input="search()"
              :shortcuts="shortcuts"
              :append-to-body="false"
              :clearable="false"
              :editable="false"
              input-class="dateSearch"
              name="DateSearch"
              v-model="selectedDate"
              valueType="date"
              format="DD/MM/YYYY"
              placeholder="เลือกช่วงเวลา"
            >
            </date-picker>
          </div>
        </v-flex>
        <v-flex xs4 class="text-xs-right">
          <v-btn
            variant="outlined"
            :v-tooltip="$t('export')"
            @click="exportData"
            :loading="loading"
            icon
            color="#BECCDB"
            style="border-radius: 50% !important"
          >
            <!-- <i class="fa fa-download" aria-hidden="true"></i> -->
            <img
              src="/static/img/exportfilter.png"
              alt
              class="responsive-img"
              style="height: 16px"
            />
          </v-btn>
          <exportxlsx ref="exbtn" :value="exportDataVoucher" style="display: none"></exportxlsx>
          <!-- <exportxlsx v-model="exportDataVoucher"></exportxlsx> -->
        </v-flex>
      </v-layout>

      <!-- <v-layout row justify-end>
        <multiselect
          style="width: 200px; margin: 0 8px"
          v-model="filter.campaign"
          :options="campaign"
          label="campaignname"
          selectLabel
          selectedLabel
          placeholder="campaign"
          @input="search"
          deselect-label
        ></multiselect>
        <div style="margin: 0px 8px; width: 200px" class="form-control">
          <datepicker @input="search" v-model="filter.dateFrom" placeholder="จาก"></datepicker>
        </div>
        <div style="margin: 0px 8px; width: 200px" class="form-control">
          <datepicker @input="search" v-model="filter.dateTo" placeholder="ถึง"></datepicker>
        </div>
      </v-layout> -->
      <div>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="showData"
          hide-actions
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr class="py-3 depatable">
              <td class="text-xs-center">{{ props.item.agencyname }}</td>
              <td class="text-xs-center">{{ props.item.status['รอตรวจสอบ'] || 0 }}</td>
              <td class="text-xs-center">{{ props.item.status['รอเอกสาร'] || 0 }}</td>
              <td class="text-xs-center">{{ props.item.status['แก้ไขเอกสาร'] || 0 }}</td>
              <td class="text-xs-center">{{ props.item.status['อนุมัติ'] || 0 }}</td>
              <td class="text-xs-center">{{ props.item.status['ไม่อนุมัติ'] || 0 }}</td>
              <td class="text-xs-center">{{ props.item.status['ยกเลิก'] || 0 }}</td>
              <td class="text-xs-center">{{ props.item.status['หมดอายุ'] || 0 }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
// import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import api from '@/api'
import config from '@/config'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import Typography from '@/components/elements/Typography.vue'
import TweenNum from 'vue-tween-number'
import DatePicker from 'vue2-datepicker'

export default {
  components: {
    Multiselect,
    DatePicker,
    exportxlsx,
    Typography,
    TweenNum
  },
  data() {
    return {
      agencyOptions: [],
      filter: {
        campaign: null,
        dateFrom: null,
        dateTo: null
      },
      loading: false,
      campaign: [],
      mainData: [],
      showData: [],
      topData: [],
      top5: [],
      topOther: [],
      tafficReport: {},
      topProduct: [],
      headers: [
        { text: 'หน่วยร่วม', align: 'center', value: 'name', sortable: false },
        { text: 'รอตรวจสอบ', align: 'center', value: '1', sortable: false },
        { text: 'รอเอกสาร', align: 'center', value: '2', sortable: false },
        { text: 'แก้ไขเอกสาร', align: 'center', value: '3', sortable: false },
        { text: 'อนุมัติ', align: 'center', value: '4', sortable: false },
        { text: 'ไม่อนุมัติ', align: 'center', value: '5', sortable: false },
        { text: 'ยกเลิก', align: 'center', value: '6', sortable: false },
        { text: 'หมดอายุ', align: 'center', value: '7', sortable: false }
      ],
      selectedDate: [null, null]
    }
  },
  computed: {
    shortcuts() {
      const currentDate = new Date()
      const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000)
      const fortyEightHoursAgo = new Date(Date.now() - 48 * 60 * 60 * 1000)
      const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
      return [
        {
          text: '24 ชั่วโมงที่แล้ว',
          onClick() {
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            const start = new Date(
              twentyFourHoursAgo.getFullYear(),
              twentyFourHoursAgo.getMonth(),
              twentyFourHoursAgo.getDate(),
              twentyFourHoursAgo.getHours(),
              twentyFourHoursAgo.getMinutes(),
              twentyFourHoursAgo.getSeconds()
            )

            const date = [start, end]
            return date
          }
        },
        {
          text: '48 ชั่วโมงที่แล้ว',
          onClick() {
            const start = new Date(
              fortyEightHoursAgo.getFullYear(),
              fortyEightHoursAgo.getMonth(),
              fortyEightHoursAgo.getDate(),
              fortyEightHoursAgo.getHours(),
              fortyEightHoursAgo.getMinutes(),
              fortyEightHoursAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )

            const date = [start, end]
            return date
          }
        },
        {
          text: 'อาทิตย์ที่แล้ว',
          onClick() {
            const start = new Date(
              oneWeekAgo.getFullYear(),
              oneWeekAgo.getMonth(),
              oneWeekAgo.getDate(),
              oneWeekAgo.getHours(),
              oneWeekAgo.getMinutes(),
              oneWeekAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            // return a Date
            const date = [start, end]
            return date
          }
        },
        {
          text: '15 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000)
            const end = new Date(currentDate)
            // return a Date
            const date = [start, end]
            return date
          }
        },
        {
          text: 'เดือนที่แล้ว',
          onClick() {
            const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
            const end = new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              new Date().getDate()
            )
            // return a Date
            const date = [start, end]
            return date
          }
        },
        {
          text: '365 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
            const end = new Date()
            // return a Date
            const date = [start, end]
            return date
          }
        }
      ]
    },
    exportDataVoucher() {
      var result = this.showData.map(el => {
        return {
          หน่วยร่วม: el.agencyname,
          รอตรวจสอบ: el.status['รอตรวจสอบ'] || 0,
          รอเอกสาร: el.status['รอเอกสาร'] || 0,
          แก้ไขเอกสาร: el.status['แก้ไขเอกสาร'] || 0,
          อนุมัติ: el.status['อนุมัติ'] || 0,
          ไม่อนุมัติ: el.status['ไม่อนุมัติ'] || 0,
          ยกเลิก: el.status['ยกเลิก'] || 0,
          หมดอายุ: el.status['หมดอายุ'] || 0
        }
      })
      return result
    },
    techhuntUrl() {
      return config.techhuntUrl
    }
  },
  mounted() {
    this.setup()
  },
  methods: {
    async exportData() {
      this.loading = true
      await this.setup()
      this.loading = false
      this.$refs.exbtn.exportxlsx()
    },
    numberFormat: function(val) {
      return numeral(val).format('0,0')
    },
    setup() {
      this.getCampaign()
      this.countCouponStatus()
      this.getTop10()
      this.gettafficReport()
      this.getTopProduct()
    },
    async search() {
      var campaign = this.filter.campaign

      let filter = {
        campaignId: null,

        dateFrom: null,
        dateTo: null
      }
      if (campaign && campaign.id) {
        filter.campaignId = campaign.id
      }

      if (this.selectedDate[0]) {
        filter.dateFrom = moment(this.selectedDate[0]).format('YYYY-MM-DD')
      }
      if (this.selectedDate[1]) {
        filter.dateTo = moment(this.selectedDate[1]).format('YYYY-MM-DD')
      }

      var result = {}
      for (const key in filter) {
        if (filter[key]) {
          Object.assign(result, { [key]: filter[key] })
        }
      }
      if (!Object.keys(result).length) {
        result = null
      }
      this.countCouponStatusWithFilter(result)
    },
    async getCampaign() {
      this.campaign = await api.getCampaign()
    },
    async gettafficReport() {
      this.tafficReport = await api.gettafficReport()
    },
    async getTopProduct() {
      this.topProduct = await api.getTopProduct(3)
    },
    async getTop10() {
      this.topData = await api.top10Product()
      if (this.topData && this.topData.length > 5) {
        this.top5 = this.topData.slice(0, 5)
        this.topOther = this.topData.slice(5)
      } else if (this.topData && this.topData.length <= 5) {
        this.top5 = this.topData
      }
    },
    async countCouponStatusWithFilter(filter = {}) {
      this.loading = true
      let res = await api.countCouponStatusWithFilter(filter)
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].status && res.data[i].status.length) {
          let obj = {}
          for (let j = 0; j < res.data[i].status.length; j++) {
            obj[res.data[i].status[j][0]] = res.data[i].status[j][1]
          }
          res.data[i].status = obj
        }
      }
      this.mainData = res.data
      this.showData = res.data
      this.loading = false
    },
    async countCouponStatus() {
      this.loading = true
      let res = await api.countCouponStatus()
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].status && res.data[i].status.length) {
          let obj = {}
          for (let j = 0; j < res.data[i].status.length; j++) {
            obj[res.data[i].status[j][0]] = res.data[i].status[j][1]
          }
          res.data[i].status = obj
        }
      }
      this.mainData = res.data
      this.showData = res.data
      this.loading = false
    },
    openUrl(url) {
      // console.log(url)
      window.location.href = url
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 120px;
  min-height: 60px;
  background-color: #182748;
  color: white;
  text-align: center;
  align-self: center;
  font-weight: bold;
}
.flex-row-end {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/view/techhuntTrafficreport/main.vue